import { Drawer } from "@mui/material";
import KbDetailScreen from "../KbDetailScreen";

interface KbArticleDrawerProps {
  open: boolean;
  articleId: string | null;
  onClose: () => void;
}

export const KbArticleDrawer = ({
  open,
  articleId,
  onClose,
}: KbArticleDrawerProps) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: "80vw", maxWidth: "1200px", height: "100vh" },
      }}
    >
      {articleId && (
        <KbDetailScreen
          fileId={articleId}
          snapshotId={articleId}
          mode="edit"
          isDrawer
          onClose={onClose}
        />
      )}
    </Drawer>
  );
};
